module.exports = __webpack_public_path__ + "static/media/_MIC2643.image.46770ba4.png";